import React from 'react';

import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

import './ConnectedCalendarIcon.scss';
import { WpIcon } from 'Wpds/components/icon';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

function ConnectedCalendarIcon() {
  const { tr } = useTranslation();
  return (
    <div className="connected-calendar-icon d-flex">
      <WpTooltip placement="top">
        <WpTooltipTrigger>
          <span className="connected-calendar-icon-calendar">
            <WpIcon name="calendar-star" />
          </span>
        </WpTooltipTrigger>
        <WpTooltipContent>{tr('perform.workspace.meeting_panel.connected_calendar_tooltip')}</WpTooltipContent>
      </WpTooltip>
    </div>
  );
}

export default ConnectedCalendarIcon;
